<!--
 * @Author: your name
 * @Date: 2021-11-10 11:35:28
 * @LastEditTime: 2021-11-10 14:46:49
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \kares_pad\src\components\schedule\windows\children\ToolsList\ToolWebpage.vue
-->
<!--网页-->

<template>
  <div class="tool-webpage">
    <!-- <iframe :src="media.ext_val_url"></iframe> -->
    <img class="field-webpage"  :class="{'scale-type':!media.ext_val_scaleType}"  src="@/assets/images/program/program_webpage_img.png.png" alt />
  </div>
</template>

<script>
export default {
  name: "ToolWebpage",
    props: {
    media: {
      type: Object,
      default: () => { }
    }
  }
}
</script>

<style lang="scss" scoped>
.tool-webpage {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .field-webpage {
    width: 100%;
    height: 100%;
    pointer-events: none;
    object-fit: contain;
  }
  .scale-type {
    object-fit: fill;
  }
}
</style>